import get from 'lodash/get'

export const isMutatingJob = (state) => get(state, ['vegetation', 'jobs', 'mutating'])


// WEBPACK FOOTER //
// ./src/modules/vegetation/selectors/jobs.js